export default __webpack_public_path__ + "static/media/HowItWorksArrow.cd737607.svg";